// Arabic labels for blog categories. Categories are stored on the backend as
// a fixed English Select field (Hudan Blog Article.category), so translation
// has to happen at render time. Lookup falls back to the raw value.
const CATEGORY_AR: Record<string, string> = {
  'General': 'عام',
  'Quran & Hifz': 'القرآن والحفظ',
  'Tajweed': 'التجويد',
  'Islamic Education': 'التربية الإسلامية',
  'Teacher Spotlight': 'أضواء على المعلمين',
  'Student Stories': 'قصص الطلاب',
  'Platform Updates': 'تحديثات المنصة',
  'Tips & Advice': 'نصائح وإرشادات',
  'Scholarly Articles': 'مقالات علمية',
};

export function blogCategoryLabel(category: string, isRTL: boolean): string {
  if (!isRTL) return category;
  return CATEGORY_AR[category.trim()] ?? category;
}
